import { render, staticRenderFns } from "./RecommendationCreation.vue?vue&type=template&id=796ac52e&"
import script from "./RecommendationCreation.vue?vue&type=script&lang=js&"
export * from "./RecommendationCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports